import { create } from 'zustand'

type DashboardState = {
	isEditMode: boolean;
  setEditMode: (isEdit: boolean) => void;
};

const useDashboardStore = create<DashboardState>()(set => ({
	isEditMode: false,
	setEditMode: isEdit => set(() => ({ isEditMode: isEdit })),
}));

export const setEditMode = (isEdit: boolean) => {
    useDashboardStore.setState({ isEditMode: isEdit })
}

export default useDashboardStore;